import Card from 'components/Shared/Card';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { SvgIcon } from 'components/Shared/SvgIcon';
import getSunFeatures from './data/features';
import Collapse from 'components/Shared/Collapse';

const features = getSunFeatures();

const useStyles = makeStyles({
  container: {
    padding: '0 24px 2px'
  },
  cardsList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '8px 14px',
    '@media screen and (max-width: 1178px)': {
      gridTemplateColumns: 'repeat(2, 1fr)'
    }
  },
  link: {
    fontWeight: 'bold',
    color: 'inherit',
    '&:visited': {
      color: 'inherit'
    }
  },
  headerImage: {
    '&#sun-feature-header-image-1': {
      padding: 8
    },
    '&#sun-feature-header-image-3, &#sun-feature-header-image-4': {
      padding: '24px 8px 0 0'
    },
    '&#sun-feature-header-image-5, &#sun-feature-header-image-6': {
      padding: '14px 16px 0 0'
    }
  }
});

const SunFeatureList: React.FC = () => {
  const classes = useStyles();

  return (
    <section className={classes.container}>
      <Collapse title="Conheça as ferramentas do Sun" storageKey={'eduzz-admin-sun-features'}>
        <div className={classes.cardsList}>
          {features.map((feature, index) => (
            <Card
              key={`sun-feature-${index + 1}`}
              headerImageElement={
                <img
                  id={`sun-feature-header-image-${index + 1}`}
                  className={classes.headerImage}
                  src={feature.backgroundImage}
                  alt={feature.title}
                />
              }
              icon={<SvgIcon name={feature.icon} />}
              title={feature.title}
              description={
                <span>
                  {feature.description}{' '}
                  {!!feature.faqLink && (
                    <a className={classes.link} href={feature.faqLink} target="__blank">
                      FAQ
                    </a>
                  )}
                </span>
              }
            />
          ))}
        </div>
      </Collapse>
    </section>
  );
};

export default React.memo(SunFeatureList);
